let map;
let markers = [];
let infoWindow;

// Initialize the map
function initStoreMap() {
  if (!window.storeLocations) {
    console.error('No store locations data found');
    return;
  }

  const sectionId = window.storeLocations.sectionId;
  const locations = window.storeLocations.locations;

  if (!locations || locations.length === 0) {
    console.error('No store locations found');
    return;
  }

  // Filter out invalid coordinates
  const validLocations = locations.filter(loc =>
    !isNaN(loc.lat) && !isNaN(loc.lng) &&
    isFinite(loc.lat) && isFinite(loc.lng)
  );

  if (validLocations.length === 0) {
    console.error('No valid store coordinates found');
    return;
  }

  // Calculate center point from all locations
  const centerLat = validLocations.reduce((sum, loc) => sum + loc.lat, 0) / validLocations.length;
  const centerLng = validLocations.reduce((sum, loc) => sum + loc.lng, 0) / validLocations.length;

  // Get scoped DOM elements
  const mapEl = document.getElementById('store-map-' + sectionId);
  if (!mapEl) {
    console.error('Map element not found: store-map-' + sectionId);
    return;
  }

  // Initialize map
  map = new google.maps.Map(mapEl, {
    center: { lat: centerLat, lng: centerLng },
    zoom: 6,
    styles: [
      {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [{ visibility: 'off' }]
      }
    ]
  });

  infoWindow = new google.maps.InfoWindow();

  // Add markers for each store
  validLocations.forEach((location, index) => {
    addMarker(location, index);
  });

  // Fit map to show all markers
  fitMapToMarkers();

  // Setup event listeners
  setupEventListeners(sectionId);
}

// Add a marker to the map
function addMarker(location, index) {
  const markerIcon = {
    url: location.markerImage || 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
    scaledSize: new google.maps.Size(40, 40),
    origin: new google.maps.Point(0, 0),
    anchor: new google.maps.Point(20, 40)
  };

  const marker = new google.maps.Marker({
    position: { lat: location.lat, lng: location.lng },
    map: map,
    title: location.name,
    animation: google.maps.Animation.DROP,
    icon: markerIcon
  });

  const contentString = `
    <div class="store-info-window">
      <h3>${location.name}</h3>
      <p>${location.address}<br>
      ${location.city}, ${location.state} ${location.zip}</p>
      ${location.phone ? `<p><strong>Phone:</strong> <a href="tel:${location.phone}">${location.phone}</a></p>` : ''}
      ${location.hours ? `<p><strong>Hours:</strong> ${location.hours}</p>` : ''}
      <a href="https://www.google.com/maps/dir/?api=1&destination=${location.lat},${location.lng}"
         target="_blank"
         rel="noopener noreferrer"
         class="directions-link">Get Directions</a>
    </div>
  `;

  marker.addListener('click', () => {
    infoWindow.setContent(contentString);
    infoWindow.open(map, marker);
    highlightStore(location.id);
  });

  markers.push({ marker, location });
}

// Fit map bounds to show all markers
function fitMapToMarkers() {
  if (markers.length === 0) return;

  if (markers.length === 1) {
    map.setCenter(markers[0].marker.getPosition());
    map.setZoom(12);
  } else {
    const bounds = new google.maps.LatLngBounds();
    markers.forEach(({ marker }) => {
      bounds.extend(marker.getPosition());
    });
    map.fitBounds(bounds);

    google.maps.event.addListenerOnce(map, 'bounds_changed', function() {
      if (map.getZoom() > 15) {
        map.setZoom(15);
      }
    });
  }
}

// Setup event listeners scoped to this section
function setupEventListeners(sectionId) {

  // Click on store item in sidebar
  document.querySelectorAll('.store-item').forEach(item => {
    item.addEventListener('click', function(e) {
      if (e.target.classList.contains('store-directions-btn')) return;

      const storeId    = this.dataset.storeId;
      const markerData = markers.find(m => m.location.id === storeId);

      if (markerData) {
        map.panTo(markerData.marker.getPosition());
        map.setZoom(15);
        google.maps.event.trigger(markerData.marker, 'click');
        highlightStore(storeId);
      }
    });
  });

  // Directions button
  document.addEventListener('click', function(e) {
    if (e.target.classList.contains('store-directions-btn')) {
      e.stopPropagation();
      const lat = e.target.dataset.lat;
      const lng = e.target.dataset.lng;
      const a   = document.createElement('a');
      a.href    = `https://www.google.com/maps/dir/?api=1&destination=${lat},${lng}`;
      a.target  = '_blank';
      a.rel     = 'noopener noreferrer';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  });

  // Search — scoped to this section's input ID
  const searchInput = document.getElementById('store-search-' + sectionId);
  if (!searchInput) {
    console.error('Search input not found: store-search-' + sectionId);
    return;
  }

  searchInput.addEventListener('input', function() {
    const searchTerm = this.value.toLowerCase().trim();

    document.querySelectorAll('.store-item').forEach(item => {
      const storeName    = item.querySelector('.store-item__name')?.textContent.toLowerCase()    || '';
      const storeAddress = item.querySelector('.store-item__address')?.textContent.toLowerCase() || '';
      const storePhone   = item.querySelector('.store-item__phone')?.textContent.toLowerCase()   || '';
      const storeHours   = item.querySelector('.store-item__hours')?.textContent.toLowerCase()   || '';

      const matches = !searchTerm              ||
        storeName.includes(searchTerm)         ||
        storeAddress.includes(searchTerm)      ||
        storePhone.includes(searchTerm)        ||
        storeHours.includes(searchTerm);

      item.style.display = matches ? 'block' : 'none';
    });
  });
}

// Highlight a store in the sidebar list
function highlightStore(storeId) {
  document.querySelectorAll('.store-item').forEach(item => {
    if (item.dataset.storeId === storeId) {
      item.classList.add('is-active');
      item.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    } else {
      item.classList.remove('is-active');
    }
  });
}

// Expose initStoreMap globally for Google Maps callback
window.initStoreMap = initStoreMap;